import { PanelAutofillArea } from "../input/PanelAutofillArea";
import { SC_Input } from "../input/SC_Input";
import { MountingSystem } from "../mountsys/MountingSystem";
import { MountingType } from "../mountsys/MountingType";
import { AreaFinder } from "../roof/areaFinder";
import { RoofShape } from "../roof/RoofShape";
import { RoofType } from "../roof/RoofType";
import { Global } from "../utilities/global";
import { Statics } from "../utilities/statics";
import { DrawRoofForPanel } from "./drawRoofForPanel";

export default function checkForInvalid(panel: any, group?: any, x?: number, y?: number) {
    let attrs = { ...panel.getAttrs() };
    if(group){
        attrs.x = attrs.x + x;
        attrs.y = attrs.y + y;
    }
    const sRange = !Global.toggleBoundaryArea ? AreaFinder.getAreaByModule(attrs) : "h";
    let invalid_panel_status: boolean = false;
    if(outOfRoof(attrs)){
        invalid_panel_status = true;
    } else {
        if (SC_Input.iMountSys != MountingSystem.SOL50_PREM_IN && SC_Input.iPnlFillArea != PanelAutofillArea.ALL) {
            if (Statics.oSpanWidthMax && Statics.oSpanWidthMax[sRange]) {
                if (Statics.oSpanWidthMax[sRange][attrs.width.toString()] == -1) {
                    invalid_panel_status = true;
                }
            } else {
                invalid_panel_status = true;
            }
        }
        if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT) {
            invalid_panel_status = false;
        }
    }
    const cross = panel.find(".invalidPanels");
    if (cross && cross.length > 0) {
        cross.forEach((item: any) => {
            item.setOpacity(invalid_panel_status ? 1 : 0);
        });
    }
    DrawRoofForPanel.layerPanel.batchDraw();

}

function outOfRoof(attrs: any) {
    let outOfRoof = false;
    const start = 100;
          
          const pW = attrs.width;
          const pH = attrs.height;
          const h = RoofShape.getCurrentRoofHeight() + 100;
          const w = RoofShape.getCurrentRoofWidth() + 100;
          if (!outOfRoof && !(attrs.x > start && attrs.x < w) || !(attrs.y > start && attrs.y < h)) {
            outOfRoof = true;
          }
          if (!outOfRoof && !((attrs.x + pW) > start && (attrs.x + pW) < w) || !((attrs.y + pH) > start && (attrs.y + pH) < h)) {
            outOfRoof = true;
          }
        //   if (!outOfRoof && (SC_Input.iRoofShape == RoofShape.WALM || SC_Input.iRoofShape == RoofShape.KRUEPPELWALM)) {
        //     // Hip
        //     const a = SC_Input.iRoofShape == RoofShape.WALM ? SC_Input.a : SC_Input.d;
        //     const b = SC_Input.b;
        //     const c = SC_Input.c;
        //     const nWing = (b - c) / 2;
        //     const area = (x1: number, y1: number, x2: number, y2: number, x3: number, y3: number) => {
        //       return Math.abs((x1 * (y2 - y3) + x2 * (y3 - y1) + x3 * (y1 - y2)) / 2.0);
        //     }
        //     const isInside = (x1: number, y1: number, x2: number, y2: number, x3: number, y3: number, x: number, y: number) => {
        //       /* Calculate area of triangle ABC */
        //       let A = area(x1, y1, x2, y2, x3, y3);

        //       /* Calculate area of triangle PBC */
        //       let A1 = area(x, y, x2, y2, x3, y3);

        //       /* Calculate area of triangle PAC */
        //       let A2 = area(x1, y1, x, y, x3, y3);

        //       /* Calculate area of triangle PAB */
        //       let A3 = area(x1, y1, x2, y2, x, y);

        //       /* Check if sum of A1, A2 and A3 is same as A */
        //       return (A == A1 + A2 + A3);
        //     }
        //     // triangleShape points
        //     //Left one
        //     let x1 = 100;
        //     let y1 = 100;
        //     let x2 = nWing + 100;
        //     let y2 = 100;
        //     let x3 = 100;
        //     let y3 = a + 100;

        //     const findLeftSide = isInside(x1, y1, x2, y2, x3, y3, attrs.x, attrs.y)
        //     //Rigthside one
        //     x1 = b - nWing + 100;
        //     y1 = 100;
        //     x2 = b + 100;
        //     y2 = 100;
        //     x3 = b + 100;
        //     y3 = a + 100;
        //     const findRightSide = isInside(x1, y1, x2, y2, x3, y3, attrs.x + pW, attrs.y + pH)
        //     const findRightSideUp = isInside(x1, y1, x2, y2, x3, y3, attrs.x + pW, attrs.y)
        //     if (findLeftSide || findRightSide || findRightSideUp) {
        //     //   outOfRoof = true;
        //     }
        //   }
    return outOfRoof;
}